"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPopoverButtonText = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Text_1 = __importDefault(require("../../../Text"));
exports.StyledPopoverButtonText = styled_components_1.default(Text_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n\n  ", ";\n"], ["\n  width: 100%;\n\n  ",
    ";\n"])), function (props) {
    return props.rtl && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      direction: rtl;\n      text-align: right;\n    "], ["\n      direction: rtl;\n      text-align: right;\n    "])));
});
var PopoverButtonText = function (props) { return react_1.default.createElement(exports.StyledPopoverButtonText, __assign({}, props)); };
exports.default = PopoverButtonText;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map